import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { AllResultsResponse } from '@/generated/src';
import { generateAPI } from '@/shared/lib';

export const useResultAllStore = defineStore('resultAll', {
  state: (): FetchState<AllResultsResponse> => ({
    data: null,
    loading: false,
    error: null,
  }),

  getters: {
    /**
     * データが存在するかどうか
     */
    hasData: (state): boolean => state.data !== null,

    /**
     * エラーメッセージ
     */
    errorMessage: (state): string | null => state.error?.message ?? null,

    /**
     * 全結果データ
     */
    allResults: (state): AllResultsResponse | null => state.data ?? null,
  },

  actions: {
    /**
     * 全結果データを取得
     */
    async fetch(basinId: string, tgttime: string, isEn?: boolean) {
      this.loading = true;
      this.error = null;

      try {
        this.data = await generateAPI().systemApi.allResultsApiApiResultBasinIdAllGet({
          basinId,
          tgttime,
          isEn,
        });
      } catch (error) {
        this.data = null;
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    /**
     * データをクリア
     */
    clear() {
      this.data = null;
      this.error = null;
    },
  },
});
